var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-tab" },
    [
      _c("chat-header", {
        attrs: { "show-close-button": _vm.showCloseButton },
        on: {
          close: function ($event) {
            return _vm.$emit("toggle-chat")
          },
        },
      }),
      _vm._v(" "),
      _c("chat-body"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-tab__input" },
        [_vm.isTypingEnabled ? _c("chat-input") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isShowingLeadsToNoRecommendation
            ? _c(
                "notification",
                { on: { close: _vm.onCloseNotification } },
                [_c("leads-to-no-recommendation-message")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }